import {
  AssetType,
  Button,
  CloseIcon,
  ConsentOrdersPathName,
  FormNavigation,
  FurnitureAndPersonalEffectsBaseProps,
  FurnitureProps_2,
  Furniture_InitialState,
  Stepper,
  toast
} from "@fla/components";
import FurnitureIcon from "@fla/components/src/assets/svgs/furniture.svg";
import { useConsentOrders } from "hooks/ConsentOrders";
import { useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { formSteps } from "./steps";

const initialState = {
  name: "",
  owner: "",
  value: "",
  split_by: "",
  sale_proceeds: "",
  percentage: {
    user: "",
    spouse: ""
  },
  comment: "",

  category: "",
  description: "",
  user_value: "",
  spouse_value: ""
};

export default function Furniture() {
  const location = useLocation() as {
    state: { child: Furniture_InitialState; parent: FurnitureAndPersonalEffectsBaseProps };
  };
  const editData = location.state?.child;

  const navigation = useNavigate();

  const [currentStep, setCurrentStep] = useState(1);
  const [formState, setFormState] = useState(
    useMemo(() => {
      if (editData?.id) {
        const obj = Object.assign({}, editData);
        delete obj.id;
        delete obj.uid;
        delete obj.createdAt;
        delete obj.updatedAt;
        delete obj.type;

        return obj;
      } else {
        return initialState;
      }
    }, [editData])
  );

  const CurrentTab = formSteps[currentStep as keyof typeof formSteps];

  const isLastStep = () => currentStep === Object.keys(formSteps).length;
  const isFirstStep = () => currentStep === 1;

  const isLast = isLastStep();
  const isFirst = isFirstStep();

  const { addAsset, deleteAsset, isDeleting, isSubmitting } = useConsentOrders();

  const handleBackClick = () => {
    if (!isFirst) {
      setCurrentStep(prev => prev - 1);
    } else {
      navigation(ConsentOrdersPathName.Furniture, {
        state: location.state?.parent,
        replace: true
      });
    }
  };

  const onSubmit = async (formData: FurnitureProps_2) => {
    setFormState(prevState => ({ ...prevState, ...formData }));

    if (!isLast) setCurrentStep(prev => prev + 1);
    else {
      try {
        addAsset({
          ...formData,
          type: AssetType.FURNITURE_AND_PERSONAL,
          id: editData?.id
        });
      } catch (error: any) {
        toast({
          type: "error",
          message: error?.message || "something went wrong, please try again!"
        });
      }
    }
  };

  const onDelete = () => {
    if (editData?.id) deleteAsset(editData.id);
  };

  return (
    <section className="w-full h-[calc(100vh_-_64px)] md:h-screen overflow-y-auto">
      <section className="w-full md:w-10/12 lg:max-w-2xl mx-auto my-10">
        <Stepper steps={[1, 2, 3]} currentStep={currentStep} classes="max-w-xs !mx-auto !my-10" />
        <div className="md:bg-white rounded-xl w-full h-fit px-10 py-5 md:shadow-md mx-auto">
          <div className="my-8 flex flex-col items-center justify-center">
            <img src={FurnitureIcon} className="w-10 h-auto my-3" alt="Furniture & personal effects" />
            <h3 className="font-bold">Furniture & personal effects</h3>
          </div>

          <CurrentTab formId="add-bank" store={formState} onSubmit={onSubmit} />

          {editData?.id ? (
            <Button
              className="mx-auto mt-10 mb-32 px-7 py-2 space-x-2 flex items-center group uppercase"
              isSubmitting={isDeleting}
              onClick={onDelete}
              // btnType="danger"
              // appearance="outline"
            >
              <CloseIcon classes="fill-current group-hover:text-white text-red-500" />
              <p>Delete</p>
            </Button>
          ) : null}

          <FormNavigation
            isFirst={false}
            isLast={isLast}
            form="add-bank"
            handleBackClick={handleBackClick}
            nextButtonText="Continue"
            isSubmitting={isSubmitting}
            disabled={isDeleting}
            classes="mt-12"
          />
        </div>
      </section>
    </section>
  );
}
